import { type Ref, watch } from "vue"

export function useMatomoGroupDimension(jobRef: Ref<FlatJob | null>) {
  if (!process.client)
    return

  let hasSetMatomoGroupDimension = false

  watch(
    () => (jobRef.value && jobRef.value.group_id) || null,
    (groupId) => {
      if (hasSetMatomoGroupDimension)
        return

      if (!groupId)
        return

      window._paq = window._paq || []
      window._paq.push(["setCustomDimension", 4, groupId])
      hasSetMatomoGroupDimension = true
    },
    { immediate: true },
  )
}
